import React from 'react';

import './BadgeCircle.css';

interface BadgeCircleProps {
  icon: string;
  alt?: string;
  backgroundColor: string;
  size: number;
}

const BadgeCircle: React.FC<BadgeCircleProps> = ({
  icon,
  alt,
  size,
  backgroundColor,
}: BadgeCircleProps) => {
  return (
    <div
      className="badge-cicle"
      style={{height: `${size}px`, width: `${size}px`}}>
      <img
        src={icon}
        alt={alt}
        style={{
          backgroundColor,
          height: '100%',
          width: '100%',
        }}
      />
    </div>
  );
};

BadgeCircle.defaultProps = {
  alt: 'badge image',
};

export default BadgeCircle;
